import { HqApp } from "./app/HqApp";

const app = new HqApp();
app.start();

if (import.meta.hot) {
  import.meta.hot.dispose(() => app.dispose());
}

window.addEventListener("beforeunload", () => app.dispose());
